export default {
    apiUrl: process.env.VUE_APP_API_URL || 'http://localhost:9000',
    accessToken: 'HdxGeZvbuLKpkgl0UeX19TxxPIOkR7RH',
}
